import { TableTemplateButtonsEvent } from "../components/table/table-template.model";

export enum SentReportStatus {
	SENT = "SENT",
	QUEUED = "QUEUED",
	IN_PROGRESS = "IN_PROGRESS",
	FAILED = "FAILED",
}

export enum SentReportRecipientType {
	PHYSICIAN = "PHYSICIAN",
	PARTICIPANT = "PARTICIPANT",
	CAREGIVER = "CAREGIVER",
}

export enum SentReportChannel {
	FAX = "FAX",
	PAUBOX = "PAUBOX",
	MANDRILL = "MANDRILL",
}

export interface SentReport {
	id: number;
	timestamp: Date;
	channel: SentReportChannel;
	from: string;
	to: string;
	recipientName: string;
	recipientType: SentReportRecipientType;
	status: SentReportStatus;
	content: string;
	actionFn: (e: TableTemplateButtonsEvent) => void;
}
